import { ConvertedComponentData } from '../../../cms/components/types'
import { InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'

export interface TrainingTeaserSliderComponentData extends ConvertedComponentData {
  backgroundColor: string;
}

export const TRAINING_TEASER_SLIDER_CONVERTER =
  new InjectionToken<Converter<CmsComponent, TrainingTeaserSliderComponentData>[]>('TrainingTeaserSliderConverter')

